import { React, useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import axiosapi from "../api/axiosapi";
import Footer from "../components/Footer";
import useAuth from '../hooks/useAuth';

const ExerciseCalculationList = () => {
    const [exerciseCalculationList, setExerciseCalculationList] = useState([]);
    const [sampleExerciseCalculationList, setSampleExerciseCalculationList] = useState([]);
    const [err, setErr] = useState();
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);
    const [openSection, setOpenSection] = useState(null);

    const toggle = (id) => {
        setOpenSection(openSection === id ? null : id);
    };

    useEffect(() => {
        const controller = new AbortController();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchExerciseList = async() => {
            try {
                const response = await axiosapi.get('/category/calculating/');
                setExerciseCalculationList(response.data);
            } catch (err) {
                setErr(err.message);
                if (err.response) {
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
        };

        const fetchSampleCalculationList = async () => {
            try {
                const response2 = await axiosapi.get('/sample/category/calculation/')
                response2.data && setSampleExerciseCalculationList(response2.data);
            } catch(err) {
                console.log(err)
            }
        }
        
        fetchExerciseList();
        fetchSampleCalculationList();

        return () => controller.abort();
    },[])

    return(
        <div className="vertical-flex-container-1">
            <div className="content-box-1">
                <div className="section">
                    <div
                        className={`section-bar ${openSection === "연산 연습 샘플" ? "active" : ""}`}
                        onClick={() => toggle("연산 연습 샘플")}
                    >
                        <span>연산 연습 샘플</span>
                        <span className="arrow">▼</span>
                    </div>

                    <div className={`card-container ${openSection === "연산 연습 샘플" ? "open" : ""}`}>
                        {sampleExerciseCalculationList && sampleExerciseCalculationList.map( category => {
                            return(
                                <div key={category.id} className="card">
                                    <h5>{category.sampleCategoryTitle}</h5>
                                    <p>{category.categoryDescription}</p>
                                    <Link 
                                        to={`/calculationexercise/sample/` }
                                        state={{
                                            "categoryCode": category.categoryCode,
                                            "problemCode": category.firstProblemCode,
                                            "categoryTitle": category.sampleCategoryTitle
                                        }}
                                    >
                                        연산 연습하기
                                    </Link>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {/* <div className="card-list-title">
                    <h4 style={{color:"sienna", fontWeight:"bold"}}>연산 연습 샘플</h4>
                </div>
                <div className="card-container">
                            {sampleExerciseCalculationList && sampleExerciseCalculationList.map( category => {
                                return(
                                    <div key={category.id} className="card">
                                        <h5>{category.sampleCategoryTitle}</h5>
                                        <p>{category.categoryDescription}</p>
                                        <Link 
                                            to={`/calculationexercise/sample/` }
                                            state={{
                                                "categoryCode": category.categoryCode,
                                                "problemCode": category.firstProblemCode,
                                                "categoryTitle": category.sampleCategoryTitle
                                            }}
                                        >
                                            연산 연습하기
                                        </Link>
                                    </div>
                                )
                            })}
                </div> */}
            </div>

            <div className="content-box-1">
                <div className="section">
                    <div
                        className={`section-bar ${openSection === "연산 연습" ? "active" : ""}`}
                        onClick={() => toggle("연산 연습")}
                    >
                        <span>연산 연습</span>
                        <span className="arrow">▼</span>
                    </div>

                    <div className={`card-container ${openSection === "연산 연습" ? "open" : ""}`}>
                        {exerciseCalculationList.map((calcul) => {
                            return (
                                <div key={calcul.id} className="card">
                                    <h4>{calcul.categoryTitle}</h4>
                                    <p>{calcul.categoryDescription}</p>
                                    <Link 
                                        to={`/calculationexercise/`}
                                        state={{
                                            "categoryCode": calcul.categoryCode,
                                            "categoryTitle": calcul.categoryTitle,
                                            "problemCode": calcul.firstProblemCode
                                        }}
                                    >
                                        연산 연습하기
                                    </Link>
                                </div>
                            )
                        })}
                    </div>
                </div>




                {/* <div className="card-list-title">
                    <h4 style={{color:"sienna", fontWeight:"bold"}}>연산 연습</h4>
                </div>
                <div className="card-container">
                            {exerciseCalculationList.map((calcul) => {
                                    return (
                                        <div key={calcul.id} className="card">
                                            <h4>{calcul.categoryTitle}</h4>
                                            <p>{calcul.categoryDescription}</p>
                                            <Link 
                                                to={`/calculationexercise/`}
                                                state={{
                                                    "categoryCode": calcul.categoryCode,
                                                    "categoryTitle": calcul.categoryTitle,
                                                    "problemCode": calcul.firstProblemCode
                                                }}
                                            >
                                                연산 연습하기
                                            </Link>
                                        </div>
                                    )
                            })}
                </div> */}
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    );
}

export default ExerciseCalculationList;